import type { Permisos } from './tipos.js';

export const CLAVES_PERMISO = ['leer', 'escribir', 'eliminar', 'compartir', 'gestionar'] as const;
export type ClavePermiso = (typeof CLAVES_PERMISO)[number];

export const ETIQUETA_PERMISO: Record<ClavePermiso, string> = {
  leer: 'Lectura',
  escribir: 'Escritura',
  eliminar: 'Eliminación',
  compartir: 'Compartir',
  gestionar: 'Gestión de permisos',
};

export const DESCRIPCION_PERMISO: Record<ClavePermiso, string> = {
  leer: 'Ver la carpeta, listar su contenido y descargar archivos.',
  escribir: 'Subir archivos, crear subcarpetas, renombrar y publicar versiones.',
  eliminar: 'Enviar elementos a la papelera y vaciarla.',
  compartir: 'Generar enlaces que dan acceso sin cuenta. Salta la lista de permisos: quien reciba el enlace entra.',
  gestionar: 'Otorgar y quitar permisos, romper o restaurar la herencia.',
};

export function unir(a: Permisos, b: Permisos): Permisos {
  return {
    leer: a.leer || b.leer,
    escribir: a.escribir || b.escribir,
    eliminar: a.eliminar || b.eliminar,
    compartir: a.compartir || b.compartir,
    gestionar: a.gestionar || b.gestionar,
  };
}

/**
 * Ninguna de las otras capacidades sirve sin lectura: quien puede subir un
 * archivo a una carpeta que no ve tendría un permiso inútil y, peor, una
 * interfaz que miente. Se normaliza al guardar y al calcular.
 */
export function normalizar(p: Permisos): Permisos {
  const algo = p.escribir || p.eliminar || p.compartir || p.gestionar;
  return { ...p, leer: p.leer || algo };
}

/** Nivel legible, para mostrar un resumen en vez de cinco casillas. */
export function nivel(p: Permisos): string {
  if (p.gestionar) return 'Control total';
  if (p.eliminar) return 'Edición completa';
  if (p.escribir) return 'Colaboración';
  if (p.leer) return 'Solo lectura';
  return 'Sin acceso';
}
